import { useContext } from 'react';

import { HotelContext } from 'app/context/HotelContext/HotelContext';

import { ExtranetInventory as LegacyInventory } from './Legacy/ExtranetInventory';
import { ExtranetInventory as ModernInventory } from './Modern/ExtranetInventory';

export const InventoryRouter = () => {
  const { hotelLoading, hotelInfo, isLegacy } = useContext(HotelContext);

  if (hotelLoading || !hotelInfo) {
    return null;
  }

  return isLegacy ? <LegacyInventory /> : <ModernInventory />;
};
